import { render, staticRenderFns } from "./ElLink.vue?vue&type=template&id=480a9436"
import script from "./ElLink.vue?vue&type=script&lang=js"
export * from "./ElLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports